import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '@material-ui/icons/Restore';

import { Button, ButtonProps } from './Button';

export const ResetButton = (props: ButtonProps): JSX.Element => {
  return (
    <Button type='button' {...props} startIcon={<Icon />}>
      <FormattedMessage
        id={'ResetButton.button.text'}
        defaultMessage={'Reset'}
      />
    </Button>
  );
};
